<template>
  <popup-layout title="부서추가" :is-show="isShow" width="500">
    <template v-slot:content>
      <v-row>
        <field-input title="부서명" cols="1">
          <v-text-field
              v-model="orgNm"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="상위부서" cols="1">
          <search-group
            placeholder="상위부서를 선택해주세요"
            :search-nm="'인카모기지'"
            :items="orgList"
            @updateData="updateData"
          />
        </field-input>
        <field-input title="시작일" cols="1">
          <single-date-input
              :start-date="stDt"
              @updateDate="updateDate"
          />
        </field-input>
        <field-input title="부서주소" cols="1">
          <v-text-field
              v-model="locationCd"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
      </v-row>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="addOrgConfirm">추가</v-btn>
        <v-btn class="button delete" outlined @click="close">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import SearchGroup from "@/common/components/SearchGroup.vue";
import SingleDateInput from "@/common/components/input/SingleDateInput.vue";
import func from "@/util/func";
import DateMixin from "@/mixin/DateMixin";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";

export default {
  name: "OrganizationAdd",
  components: {SingleDateInput, SearchGroup, FieldInput, PopupLayout},
  props: ["isShow"],
  mixins: [DateMixin],
  data() {
    return {
      locationCd: "",
      dispOrd: 0,
      orgNm: "",
      leaderId: "",
      stDt: "",
      orgList: [],
      selectGroup: {}
    }
  },
  computed: {
    ...mapGetters("login", {
      userData: "userData",
      isAdmin: "isAdmin",
      memberId: "memberId"
    }),
    endDate() {
      const now = new Date();
      const year = now.getFullYear() + 200;
      const month = this.addZero(now.getMonth() + 1);
      const day = this.addZero(now.getDate());
      return `${year}${month}${day}`
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        this.setToday();
        this.getOrgList();
      }
    }
  },
  methods: {
    setToday() {
      this.stDt = func.getToday();
    },
    async getOrgList() {
      const orgCd = this.isAdmin ? "" : this.userData.orgCd;
      this.orgList = await func.getOrgList(orgCd, "Y", "N", "");
      this.selectGroup = this.orgList[0];
    },
    updateData(item) {
      this.selectGroup = item;
    },
    updateDate(value) {
      this.stDt = value;
    },
    addOrgConfirm() {
      this.showConfirm({
        message: "입력하신 부서를 추가하시겠습니까?",
        successCallback: () => {
          this.addDepart();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async addDepart() {
      const orgData = {
        orgNm: this.orgNm,
        upperOrgCd: Number(this.selectGroup.id),
        orgTypeCd: "-",
        leaderId: "-",
        locationCd: "",
        dispOrd: "0",
        useYn: "Y",
        stDt: this.stDt.replaceAll("-", ""),
        createId: this.memberId
      };
      if (!orgData.upperOrgCd) {
        this.showAlert({message: "상위부서를 선택해주세요"});
        return;
      }
      try {
        await axiosInstance.post("/admin/org/org", orgData)
            .then(() => {
              this.showAlert({
                message: "부서 추가를 완료했습니다",
                successCallback: () => {
                  this.$emit("refresh");
                  this.$emit("close");
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    close() {
      this.setToday();
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  display: flex;
  justify-content: center;
}
</style>